
var minibasket = {
    init: function () {
        // Classic woocommerce jQuery
        jQuery(document).ready(function($) {

            // Listen to the update button on the mini cart
            $( document ).on( "click", ".js-update-mini-cart", function(e) {

                e.preventDefault();

                var cart_item_key = $(this).attr('data-cart_item_key');
                var quantity = $('[name="cart[' + cart_item_key + '][qty]"]').val();

                $.ajax({
                    type: 'POST',
                    url: wp_ajax.url,
                    data: {
                        action: 'update_cart',
                        cart_item_key: cart_item_key,
                        quantity: quantity,
                    },
                    success: function(response) {
                        $(document.body).trigger('wc_fragment_refresh');

                        //Remove existing notices
                        $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                        let notice = '<div class="woocommerce-message wcom-notice">Your basket has been updated.</div>';

                        // Add new notices to offcanvas
                        setTimeout(function () {
                            $('.woocommerce-mini-cart').prepend(notice);
                        }, 1000);
                    },
                });
            });
        });
    },
}

export default minibasket;
